/**
 * Отправляем сообщение на сервер.
 */
async function sendFeedback({ name, email, message }) {
  try {
    /**
     * Отправляет POST-запрос на сервер с данными формы.
     * @type {Response}
     */
    const response = await fetch("/api/feedback", {
      method: "POST",
      body: JSON.stringify({
        name,
        email,
        message,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response;
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
}

export default sendFeedback;
